import React from 'react';
import { ShadowView } from '../../../../helperComponents/ShadowView';
import { StyleSheet, Text, View } from 'react-native';
import {
    mbApplyTransparency,
    mbTextStyles,
} from '@mightybyte/rnw.utils.style-utils';
import Fontisto from 'react-native-vector-icons/Fontisto';
import { ArrowRight } from '../../../../../resources/svgComponents/ArrowRight';
import { textStyles } from '../../../../../constants/textStyles';
import { Spacer } from '../../../../helperComponents/Spacer';
import GradientContainer from '../../../../helperComponents/gradients/GradientContainer';

type CardProps = {
    icon: React.ReactChild;
    color: string | [string, string];
    title: string;
    text: string;
    isLocked: boolean;
    enabled?: boolean;
    disabledMessage?: string;
    onPress?: () => void;
};

export default function Card({
    icon,
    color,
    title,
    text,
    isLocked,
    enabled = true,
    disabledMessage = 'Coming Soon!',
    onPress,
}: CardProps) {
    const Container = enabled ? ShadowView : View;
    return (
        <Container
            style={[
                styles.card,
                styles.cardContainer,
                !enabled && styles.disabledCard,
            ]}
            onPress={isLocked ? undefined : onPress}
        >
            <ShadowView style={{ borderRadius: 12 }}>
                <GradientContainer
                    style={styles.icon}
                    colors={typeof color === 'string' ? [color, color] : color}
                >
                    {icon}
                </GradientContainer>
            </ShadowView>
            <Spacer width={20} />
            <View style={styles.content}>
                <View style={styles.title}>
                    <Text style={[styles.titleText, !enabled && styles.titleTextWithBadge]}>{title}</Text>
                    {!enabled && (
                        <View style={styles.note}>
                            <Fontisto name="locked" color="#FFFFFF" size={10} />
                            <Text style={styles.noteText}>{disabledMessage}</Text>
                        </View>
                    )}
                    {enabled && isLocked && (
                        <Fontisto name="locked" color="#EE3823" size={14} />
                    )}
                </View>
                <Text style={styles.textText}>{text}</Text>
            </View>
            {enabled && (
                <>
                    <Spacer width={20} />
                    <View>
                        <ArrowRight />
                    </View>
                </>
            )}
        </Container>
    );
}

const styles = StyleSheet.create({
    card: {
        borderRadius: 10,
        justifyContent: 'center',
    },
    cardContainer: {
        padding: 20,
        flexDirection: 'row',
        alignItems: 'center',
    },
    disabledCard: {
        borderWidth: 1,
        backgroundColor: '#F0F0F3',
        borderColor: mbApplyTransparency('#000000', 0.16),
    },
    icon: {
        height: 63,
        width: 84,
        borderRadius: 12,
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
    title: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    titleText: mbTextStyles([
        textStyles.smallText,
        {
            color: '#292E30',
            fontSize: 18,
            fontWeight: '600',
            marginRight: 8,
            textAlign: 'left',
        },
    ]),
    titleTextWithBadge: {
        marginRight: 0,
        flex: 0,
        flexShrink: 1,
    },
    textText: mbTextStyles([
        textStyles.smallText,
        {
            color: '#677278',
            fontSize: 14,
            fontWeight: '400',
            marginTop: 5,
            textAlign: 'left',
        },
    ]),
    content: {
        flex: 1,
    },
    note: {
        backgroundColor: '#EE3823',
        flexDirection: 'row',
        paddingHorizontal: 10,
        borderRadius: 5,
        height: 22,
        alignItems: 'center',
    },
    noteText: mbTextStyles([
        textStyles.smallText,
        {
            color: '#FFFFFF',
            fontSize: 10,
            fontWeight: '600',
            marginLeft: 5,
            textAlign: 'left',
        },
    ]),
});
